/* eslint-disable */
import createIcon from '../createIcon';

const IconCloseOutlined = createIcon({
  name: 'icon-close-outlined',
  content: '<path d="M174.851027 804.799004l630.840074-630.840074 45.050903 45.050902-630.840075 630.840075z"/><path d="M805.436217 849.786185l-630.840075-630.840074 45.050902-45.050903 630.840075 630.840075z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCloseOutlined;
